module.exports = __webpack_public_path__ + "img/kk-active.a5d62eca.png";